import { apiClient } from "@/api"
import Alerter from "@/common/alerter"
import { MeetingFormats } from "@/constants"
import { className } from "@/helpers/className"
import useViewport from "@/hooks/useViewport"
import moment from "moment-timezone"
import { useCallback, useEffect, useState } from "react"

const useFetchStudent = ({ student_id }) => {
  const { isMobileViewport } = useViewport()
  const [studentData, setStudentData] = useState(null)

  const fetchStudents = useCallback(async () => {
    try {
      const timeZone = moment.tz.guess()
      const { data } = await apiClient.get(`/api/v2/students/${student_id}`, { params: { time_zone: timeZone } })
      setStudentData(data)
    } catch (error) {
      Alerter.error(`Failed to fetch student data \n${error}`)
    }
  }, [student_id])

  useEffect(() => {
    fetchStudents()
  }, [fetchStudents])

  const nextSession = studentData?.next_session
  const doesNextSessionExist = Boolean(nextSession) && Object.keys(nextSession || {}).length > 1
  const canStartNextSession = nextSession && moment(nextSession.scheduled_at).isBefore(moment().add(5, "minutes"))
  const cardClass = className(isMobileViewport ? "px-3 py-4" : "", doesNextSessionExist ? "next-lesson" : "no-lesson")
  const isLessonspace = nextSession?.location === MeetingFormats.LessonSpace

  return {
    studentData,
    fetchStudents,
    canStartNextSession,
    cardClass,
    doesNextSessionExist,
    nextSession,
    isLessonspace,
  }
}

export default useFetchStudent
